import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <GoogleReCaptchaProvider
            
                reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITEKEY ? process.env.REACT_APP_CAPTCHA_SITEKEY : ""}
                container={{ // optional to render inside custom element
                    element: "recaptchaform",
                    parameters: {
                        badge: 'bottomright', // optional, default undefined
                        theme: 'dark', // optional, default undefined
                    }
                }}
            >
                <App />
                
            </GoogleReCaptchaProvider>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

registerServiceWorker();
